<template slot="body" scope="props">
<span>
    {{displayNumber}}
</span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'animated-number',
    data () {
        return {
            displayNumber: 0,
            interval: false
        }
    },
    props: {
        number: Number
    },
    computed: {
        ...mapGetters({
            firstTimeLogIn: 'firstTimeLogIn'
        })
    },
    methods: {
        count () {
            this.interval = window.setInterval(function () {
                if (this.displayNumber !== this.number) {
                    let change = (this.number - this.displayNumber) / 10
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change)
                    this.displayNumber = this.displayNumber + change
                }
            }.bind(this), 50)
        }
    },
    mounted () {
        if (this.firstTimeLogIn) {
            this.count()
        } else {
            this.displayNumber = this.number
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/counter/animated-number.vue